import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=b558b88e&scoped=true&"
import script from "./Material.vue?vue&type=script&lang=js&"
export * from "./Material.vue?vue&type=script&lang=js&"
import style0 from "./Material.vue?vue&type=style&index=0&id=b558b88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b558b88e",
  null
  
)

export default component.exports